import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-integration',
  templateUrl: './payment-integration.component.html',
  styleUrls: ['./payment-integration.component.css']
})
export class PaymentIntegrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/payment-integration/payment-integration.component.ts